// Rótulos/cores dos enums de Serviço/Contrato - mesma convenção de
// cor lisa fixa já usada em ticketUtils.js.
export const TIPO_COBRANCA_LABELS = {
    avulso: 'Avulso',
    recorrente: 'Recorrente'
};

export const RECORRENCIA_PERIODO_LABELS = {
    dias: 'dias',
    semanas: 'semanas',
    meses: 'meses'
};

export const CONTRATO_STATUS_LABELS = {
    ativo: 'Ativo',
    pausado: 'Pausado',
    cancelado: 'Cancelado',
    concluido: 'Concluído'
};

export const CONTRATO_STATUS_COLORS = {
    ativo: { bg: '#D6F5DD', color: '#1B7A3D' },
    pausado: { bg: '#FFF3CD', color: '#8A6D00' },
    cancelado: { bg: '#E5E5E5', color: '#555555' },
    concluido: { bg: '#DCEEFF', color: '#0B5FA5' }
};

export const STATUS_PAGAMENTO_LABELS = {
    pendente: 'Pendente',
    pago: 'Pago'
};

export const STATUS_PAGAMENTO_COLORS = {
    pendente: { bg: '#FDE4CF', color: '#9A4A00' },
    pago: { bg: '#D6F5DD', color: '#1B7A3D' }
};

export const formatServicoDate = (value) => {
    if (!value) return '—';
    try {
        return new Date(`${value}T00:00:00`).toLocaleDateString('pt-BR');
    } catch {
        return '—';
    }
};

export const recorrenciaResumo = (servico) => {
    if (!servico || servico.tipo_cobranca !== 'recorrente') return TIPO_COBRANCA_LABELS.avulso;
    if (!servico.recorrencia_intervalo || !servico.recorrencia_periodo) return TIPO_COBRANCA_LABELS.recorrente;
    return `A cada ${servico.recorrencia_intervalo} ${RECORRENCIA_PERIODO_LABELS[servico.recorrencia_periodo] || servico.recorrencia_periodo}`;
};
